import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointsReasonsCell } from './charge-points-reasons.cell';
import { ChargePointsReasonsHeader } from './charge-points-reasons.header';

export const ChargePointsReasonsColumn: IdentifiedColumnDef<
  GatewayChargePointInMaintenanceModel,
  GatewayChargePointInMaintenanceModel['reasons']
> = {
  enableSorting: false,
  header: ChargePointsReasonsHeader,
  cell: ChargePointsReasonsCell,
};
